import PermissionContent from "./PermissionContent";

export default PermissionContent;
